import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {WithdrawalStatus} from '@gatewee/types/withdrawal';

@Pipe({
  name: 'withdrawalStatus',
  pure: false,
  standalone: false,
})
export class WithdrawalStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: WithdrawalStatus | string | undefined): string {
    return (
      this.translate.instant(`enums.withdrawalStatus.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
